import { FC } from 'react';

import { PersonalizedBadge, UnauthorizedPublicEntertainer } from '@queries/EntertainerQueries';

import { useAnalytics } from '@hooks/useAnalytics';

import { useRouter } from '@router/index';

import IconButton from '@components/buttons/IconButton';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';
import { AsyncImage } from '@components/layout/AsyncImg';

export const PersonalizedBadgeSection: FC<{
  entertainer: UnauthorizedPublicEntertainer;
  personalizedBadge: PersonalizedBadge;
}> = ({ personalizedBadge }) => {
  const { navigate } = useRouter();
  const handleNavigateToTopKingMaterial = () => {
    navigate(`/noauth/personalized-badge/${personalizedBadge._id}`);
  };

  return (
    <div
      className="d-flex gap-3 p-2 align-items-center mb-3"
      style={{ background: 'rgba(255,255,255,.1)', borderRadius: 8 }}
      onClick={handleNavigateToTopKingMaterial}
    >
      <div>
        {personalizedBadge?.imgUrl ? (
          <AsyncImage
            placeholder={
              <div
                style={{
                  height: 64,
                  width: 64,
                  display: 'block',
                }}
              />
            }
            src={personalizedBadge?.imgUrl}
            style={{
              height: 64,
              width: 64,
              display: 'block',
            }}
          />
        ) : (
          <></>
        )}
      </div>
      <div>
        <strong className="fs-6">{personalizedBadge.title}</strong>
        <br />
        <span>{personalizedBadge.description}</span>
      </div>
      <div>
        <IconButton color="neutral" variant="flat">
          <FontAwesomeIcon name="chevron-right" />
        </IconButton>
      </div>
    </div>
  );
};
